module.exports = __webpack_public_path__ + "img/logo-wm.f49f2678.png";